<nav class="sr-only skip-link-nav" aria-label="Skip links">
    <a [routerLink]="[]" fragment="maincontent"  [attr.href]="'#maincontent'" class="skip-link">Skip to Main Content</a>
    <a [routerLink]="[]" fragment="footer" [attr.href]="'#footer'" class="skip-link">Skip to Footer</a>
</nav>
<div class="d-flex flex-column">
  @if (!hideHeader) {
    <app-header [isUserLoggedIn]="isUserLoggedIn"></app-header>
  }
    <div [ngClass]="{'container-fluid px-0': isAdmin}">
    <div [ngClass]="{'row no-gutters flex-nowrap': isAdmin}">
      @if (isUserLoggedIn && isAdmin) {
        <app-left-nav
          (isLeftNavCollapsed)="toggleLeftNav($event)" class="sidebar-wrapper col-auto d-none d-md-block"
          [ngClass]="{'sidebar-hidden': isLeftNavCollapsed}">
        </app-left-nav>
      }
      @if (loading) {
        <div class="main page-loader col p-4" role="status" aria-label="Loading">
          <app-loader></app-loader>
        </div>
      }
      <ng-container>
        @if (!isAdmin) {
          <div [hidden]="loading" id="main">
            <router-outlet></router-outlet>
          </div>
        } @else {
          <div [hidden]="loading" class="main-wrapper "
            [ngClass]="{'col p-4': !isLeftNavCollapsed, 'col-lg-12 col-md-12 px-0 left-nav-collapsed': isLeftNavCollapsed}"
            style="min-width:0; overflow-x:clip;"
            id="main">
            <router-outlet></router-outlet>
          </div>
        }
      </ng-container>
    </div>
  </div>
  <p-toast [showTransitionOptions]="'0ms linear'" [hideTransitionOptions]="'0ms linear'" position="bottom-right"></p-toast>
  <app-footer></app-footer>
  @if (clientCss) {
    <link rel="stylesheet" [href]="clientCss | safeUrl" type="text/css"/>
  }
</div>
@if (environment === Environments.LOCAL) {
  <app-dev-panel></app-dev-panel>
}
@if (showInactiveTimeout === true) {
  <app-yes-no-modal (onYesSelect)="resetInactivity()" [yesButtonText]="'Stay Logged In'" [noButtonText]="'Log Out'"
    (onNoSelect)="logout()" headerText="Inactivity Warning">
    <div role="alert">
      <p><span aria-atomic="true" aria-live="polite">Your session will expire in {{inactivityTimeout}}</span>. Do you want to continue?</p>
    </div>
  </app-yes-no-modal>
}
<app-mfa-enrollment-interstitial></app-mfa-enrollment-interstitial>
